var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#73AF00"
    },
    width: 512,
    height: 512
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.789,
    style: {
      fill: "#FF4B55"
    },
    width: 134.74,
    height: 512
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "166.053,58.386 139.105,80.842 85.211,80.842 58.263,58.386 58.263,35.93 85.211,13.474   139.105,13.474 166.053,35.93 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#73AF00"
    },
    points: "166.053,247.018 139.105,269.474 85.211,269.474 58.263,247.018 58.263,224.561    85.211,202.105 139.105,202.105 166.053,224.561  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#73AF00"
    },
    points: "166.053,152.702 139.105,175.158 85.211,175.158 58.263,152.702 58.263,130.246    85.211,107.789 139.105,107.789 166.053,130.246  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#73AF00"
    },
    points: "166.053,341.333 139.105,363.789 85.211,363.789 58.263,341.333 58.263,318.877    85.211,296.421 139.105,296.421 166.053,318.877  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFB400"
    },
    points: "44.789,67.368 71.737,94.316 44.789,121.263  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFB400"
    },
    points: "179.526,121.263 152.579,94.316 179.526,67.368  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFB400"
    },
    points: "44.789,161.684 71.737,188.632 44.789,215.579  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFB400"
    },
    points: "179.526,215.579 152.579,188.632 179.526,161.684  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFB400"
    },
    points: "44.789,256 71.737,282.947 44.789,309.895  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFB400"
    },
    points: "179.526,309.895 152.579,282.947 179.526,256  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFB400"
    },
    points: "44.789,350.316 71.737,377.263 44.789,404.211  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFB400"
    },
    points: "179.526,404.211 152.579,377.263 179.526,350.316  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFB400"
    },
    points: "44.789,0 71.737,0 44.789,26.947  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFB400"
    },
    points: "179.526,26.947 152.579,0 179.526,0  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.42,
    y: 107.79,
    style: {
      fill: "#FFB400"
    },
    width: 13.474,
    height: 67.37
  })), /*#__PURE__*/React.createElement("rect", {
    x: 85.21,
    y: 134.74,
    style: {
      fill: "#FF4B55"
    },
    width: 53.894,
    height: 13.474
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFB400"
    },
    points: "152.579,119.017 139.105,107.789 139.105,175.158 152.579,163.929  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFB400"
    },
    points: "71.737,163.929 85.211,175.157 85.211,107.79 71.737,119.017  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFB400"
    },
    points: "112.158,13.474 85.211,13.474 58.263,35.929 58.263,47.158 112.158,47.158  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFB400"
    },
    points: "112.158,80.842 139.104,80.842 166.053,58.387 166.053,47.158 112.158,47.158  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4B55"
    },
    points: "112.158,67.368 85.211,47.237 112.158,26.947 139.105,47.237 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#73AF00"
    },
    points: "112.158,67.368 139.105,47.237 139,47.158 112.158,47.158  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#73AF00"
    },
    points: "112.158,47.158 112.158,26.947 85.316,47.158  "
  })), /*#__PURE__*/React.createElement("rect", {
    x: 85.21,
    y: 215.58,
    style: {
      fill: "#FF4B55"
    },
    width: 53.895,
    height: 40.42
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.1,
    y: 229.05,
    style: {
      fill: "#FFB400"
    },
    width: 13.474,
    height: 13.474
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.42,
    y: 229.05,
    style: {
      fill: "#F5F5F5"
    },
    width: 13.474,
    height: 13.474
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.42,
    y: 309.89,
    style: {
      fill: "#FF4B55"
    },
    width: 13.474,
    height: 13.474
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 125.63,
    y: 323.37,
    style: {
      fill: "#FFB400"
    },
    width: 13.474,
    height: 13.474
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.21,
    y: 323.37,
    style: {
      fill: "#FFB400"
    },
    width: 13.474,
    height: 13.474
  })), /*#__PURE__*/React.createElement("rect", {
    x: 105.42,
    y: 336.84,
    style: {
      fill: "#FF4B55"
    },
    width: 13.474,
    height: 13.474
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.74,
    y: 229.05,
    style: {
      fill: "#FFB400"
    },
    width: 13.474,
    height: 13.474
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "166.053,435.649 139.105,458.105 85.211,458.105 58.263,435.649 58.263,413.193   85.211,390.737 139.105,390.737 166.053,413.193 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFB400"
    },
    points: "112.158,390.737 85.211,390.737 58.263,413.192 58.263,424.421 112.158,424.421  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFB400"
    },
    points: "112.158,458.105 139.104,458.105 166.053,435.65 166.053,424.421 112.158,424.421  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4B55"
    },
    points: "139.105,431.158 112.158,444.632 85.211,431.158 85.211,417.684 112.158,404.211   139.105,417.684 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M364.384,73.366c-1.435-0.705-2.733,1.162-1.57,2.259c15.248,14.389,24.884,34.595,24.884,57.134   c0,44.274-35.587,79.795-79.346,79.795c-8.078,0-15.856-1.26-23.195-3.553c-1.521-0.475-2.504,1.565-1.195,2.474   c12.793,8.894,28.215,14.209,45.047,14.209c44.339,0,80.569-35.524,80.569-80.44C409.578,113.676,391.05,86.473,364.384,73.366z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M254.737,125.351l-3.297,9.324l7.754,6.138c1.004,0.795,0.419,2.41-0.861,2.377l-9.886-0.254   l-3.441,9.272c-0.445,1.2-2.163,1.143-2.527-0.085l-2.813-9.481l-9.881-0.407c-1.279-0.053-1.755-1.704-0.7-2.429l8.148-5.605   l-2.666-9.523c-0.345-1.233,1.078-2.196,2.094-1.417l7.849,6.017l8.233-5.478C253.809,123.089,255.164,124.144,254.737,125.351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M294.78,145.575l-3.297,9.324l7.754,6.138c1.004,0.795,0.419,2.41-0.861,2.377l-9.886-0.254   l-3.441,9.272c-0.445,1.2-2.163,1.143-2.527-0.085l-2.813-9.481l-9.881-0.407c-1.279-0.053-1.755-1.704-0.7-2.429l8.148-5.605   l-2.666-9.523c-0.345-1.233,1.078-2.196,2.094-1.417l7.849,6.017l8.233-5.478C293.851,143.312,295.207,144.368,294.78,145.575z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M294.375,103.914l-3.297,9.324l7.754,6.138c1.004,0.795,0.419,2.41-0.861,2.377l-9.886-0.254   l-3.441,9.272c-0.445,1.2-2.163,1.143-2.527-0.085l-2.813-9.481l-9.881-0.407c-1.279-0.053-1.755-1.704-0.7-2.429l8.148-5.605   l-2.666-9.523c-0.345-1.233,1.078-2.196,2.094-1.417l7.849,6.017l8.233-5.478C293.447,101.651,294.802,102.707,294.375,103.914z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M295.739,63.703l-3.297,9.324l7.754,6.138c1.004,0.795,0.419,2.41-0.861,2.377l-9.886-0.254   l-3.441,9.272c-0.445,1.2-2.163,1.143-2.527-0.085l-2.813-9.481l-9.881-0.407c-1.279-0.053-1.755-1.704-0.7-2.429l8.148-5.605   l-2.666-9.523c-0.345-1.233,1.078-2.196,2.094-1.417l7.849,6.017l8.233-5.478C294.811,61.44,296.166,62.496,295.739,63.703z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M334.973,83.927l-3.297,9.324l7.754,6.138c1.004,0.795,0.419,2.41-0.861,2.377l-9.886-0.254   l-3.441,9.272c-0.445,1.2-2.163,1.143-2.527-0.085l-2.813-9.481l-9.881-0.407c-1.279-0.053-1.755-1.704-0.7-2.429l8.148-5.605   l-2.666-9.523c-0.345-1.233,1.078-2.196,2.094-1.417l7.849,6.017l8.233-5.478C334.044,81.664,335.4,82.72,334.973,83.927z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTm);
export default __webpack_public_path__ + "static/media/TM.bb4af79d2f830e5af4886a13a8f5845a.svg";
export { ForwardRef as ReactComponent };